module.exports = __webpack_public_path__ + "media/images/front/team/belen_fortea-443e4f59af29e4ce57ad298066b6c283.jpg";